module.exports = __webpack_public_path__ + "static/media/Deer_stone_icon_200px.784f8df8.png";